module.exports = __webpack_public_path__ + "media/Radiohead - Paranoid Android.895c5523.mp3";